var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsHomeRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:home-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.99992 17.5833C4.54159 17.5833 4.14909 17.42 3.82242 17.0933C3.49575 16.7667 3.3327 16.3744 3.33325 15.9167V8.41667C3.33325 8.15278 3.39242 7.90278 3.51075 7.66667C3.62909 7.43056 3.79214 7.23611 3.99992 7.08333L8.99992 3.33333C9.1527 3.22222 9.31242 3.13889 9.47909 3.08333C9.64575 3.02778 9.81936 3 9.99992 3C10.1805 3 10.3541 3.02778 10.5208 3.08333C10.6874 3.13889 10.8471 3.22222 10.9999 3.33333L15.9999 7.08333C16.2083 7.23611 16.3716 7.43056 16.4899 7.66667C16.6083 7.90278 16.6671 8.15278 16.6666 8.41667V15.9167C16.6666 16.375 16.5033 16.7675 16.1766 17.0942C15.8499 17.4208 15.4577 17.5839 14.9999 17.5833H11.6666V11.75H8.33325V17.5833H4.99992Z",
    fill: "#C5C5C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsHomeRounded);
export default __webpack_public_path__ + "static/media/material-symbols_home-rounded.12ab04c11dc5df855ac59189ab36245f.svg";
export { ForwardRef as ReactComponent };